import type { NavigateOptions } from 'react-router-dom';

export const updateUrlParam = (key: string, value: string | null, navigate: (url: string, options?: NavigateOptions) => void) => {
  const url = new URL(window.location.href);

  if (value == null) {
    url.searchParams.delete(key);
  } else {
    url.searchParams.set(key, value);
  }

  navigate(url.pathname + url.search, { replace: true });
};
